'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Button, EmptyState } from '@/shared/components/ui';
import { FeatherAlertCircle, FeatherChevronDown, FeatherChevronUp, FeatherFlame, FeatherSnowflake, FeatherThermometer } from '@subframe/core';
import type { LoteSectionCardProps } from '../../types/lote.types';
import { LoteCompactTable } from './LoteCompactTable';
export function LoteSectionCard(t0) {
  const $ = _c(57);
  const {
    section,
    selectedIds,
    onToggleSelect,
    onSelectAll,
    onCardClick,
    onPauseClick,
    onResumeClick,
    isExpanded,
    onToggleExpand
  } = t0;
  let t1;
  if ($[0] !== section.colorClass || $[1] !== section.iconType) {
    t1 = () => {
      const iconClass = `h-5 w-5 ${section.colorClass}`;
      switch (section.iconType) {
        case "flame":
          {
            return <FeatherFlame className={iconClass} />;
          }
        case "thermometer":
          {
            return <FeatherThermometer className={iconClass} />;
          }
        case "snowflake":
          {
            return <FeatherSnowflake className={iconClass} />;
          }
        case "alert":
          {
            return <FeatherAlertCircle className={iconClass} />;
          }
        default:
          {
            return null;
          }
      }
    };
    $[0] = section.colorClass;
    $[1] = section.iconType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getSectionIcon = t1;
  let t2;
  if ($[3] !== section.items || $[4] !== selectedIds) {
    t2 = section.items.length > 0 && section.items.every(item => selectedIds.has(item.id));
    $[3] = section.items;
    $[4] = selectedIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const allSelected = t2;
  let t3;
  if ($[6] !== section.items || $[7] !== selectedIds) {
    let t4;
    if ($[9] !== selectedIds) {
      t4 = item_0 => selectedIds.has(item_0.id);
      $[9] = selectedIds;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = section.items.filter(t4);
    $[6] = section.items;
    $[7] = selectedIds;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const selectedInSection = t3.length;
  if (section.count === 0) {
    return null;
  }
  const t4 = `section-${section.id}`;
  const t5 = `flex h-10 w-10 items-center justify-center rounded-lg ${section.bgClass}`;
  let t6;
  if ($[11] !== getSectionIcon) {
    t6 = getSectionIcon();
    $[11] = getSectionIcon;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== section.title) {
    t8 = <h2 className="text-heading-3 font-heading-3 text-default-font">{section.title}</h2>;
    $[16] = section.title;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = section.count === 1 ? "negocia\xE7\xE3o" : "negocia\xE7\xF5es";
  let t10;
  if ($[18] !== section.count || $[19] !== t9) {
    t10 = <p className="text-caption font-caption text-subtext-color">{section.count} {t9}</p>;
    $[18] = section.count;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <div className="flex flex-col gap-1">{t8}{t10}</div>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t7) {
    t12 = <div className="flex items-center gap-3">{t7}{t11}</div>;
    $[24] = t11;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== allSelected || $[28] !== onSelectAll || $[29] !== section.items.length || $[30] !== selectedInSection) {
    t13 = section.items.length > 0 && <><Button variant="neutral-tertiary" size="small" onClick={onSelectAll} className="max-md:hidden">{allSelected ? "Desmarcar todos" : "Selecionar todos"}</Button>{selectedInSection > 0 && <Badge variant="neutral" className="max-md:hidden">{selectedInSection} selecionados</Badge>}</>;
    $[27] = allSelected;
    $[28] = onSelectAll;
    $[29] = section.items.length;
    $[30] = selectedInSection;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== isExpanded) {
    t14 = isExpanded ? <FeatherChevronUp /> : <FeatherChevronDown />;
    $[32] = isExpanded;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const t15 = isExpanded ? "Recolher" : "Expandir";
  let t16;
  if ($[34] !== onToggleExpand || $[35] !== t14 || $[36] !== t15) {
    t16 = <Button variant="neutral-tertiary" size="small" icon={t14} onClick={onToggleExpand}>{t15}</Button>;
    $[34] = onToggleExpand;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t13 || $[39] !== t16) {
    t17 = <div className="flex items-center gap-2">{t13}{t16}</div>;
    $[38] = t13;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t12 || $[42] !== t17) {
    t18 = <div className="flex items-center justify-between">{t12}{t17}</div>;
    $[41] = t12;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== isExpanded || $[45] !== onCardClick || $[46] !== onPauseClick || $[47] !== onResumeClick || $[48] !== onToggleSelect || $[49] !== section.colorClass || $[50] !== section.items || $[51] !== selectedIds) {
    t19 = isExpanded && <>{section.items.length === 0 ? <EmptyState icon="search" title={"Nenhuma negocia\xE7\xE3o encontrada"} description={"N\xE3o h\xE1 negocia\xE7\xF5es nesta categoria no momento."} /> : <LoteCompactTable items={section.items} selectedIds={selectedIds} onToggleSelect={onToggleSelect} onRowClick={onCardClick} onPauseClick={onPauseClick} onResumeClick={onResumeClick} colorClass={section.colorClass} />}</>;
    $[44] = isExpanded;
    $[45] = onCardClick;
    $[46] = onPauseClick;
    $[47] = onResumeClick;
    $[48] = onToggleSelect;
    $[49] = section.colorClass;
    $[50] = section.items;
    $[51] = selectedIds;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== t18 || $[54] !== t19 || $[55] !== t4) {
    t20 = <div id={t4} className="flex w-full flex-col gap-4 rounded-xl border border-neutral-200 bg-white p-6">{t18}{t19}</div>;
    $[53] = t18;
    $[54] = t19;
    $[55] = t4;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  return t20;
}